import React from "react";
import { Helmet } from "react-helmet";

import { Navbar } from "../components/navbar/Navbar";
import { HeroImg } from "../components/heroImages/HeroImg";
import { Footer } from "../components/footer/Footer";
import { Work } from "../components/work/Work";
// import config from "../contact/config";
import config from "../components/contact/config";

export const Home = () => {
  const myCurrentRole = config.myCurrentRole;
  const myDesignation = config.myDesignation;
  const mySkills = config.mySkills;
  
  return (
    <div>
     <Helmet>
        <title>{` ${myCurrentRole} and ${myDesignation}`}</title>
        <meta name="description" content={mySkills}  />

        {/* Open Graph Meta Tags (Facebook) */}
        <meta property="og:title" content="Contact Me" />
        <meta property="og:description" content="Contact me for new projects, technologies, and design challenges." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://your-website-url.com/contact" />
        <meta property="og:image" content="https://your-website-url.com/og-image.jpg" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact Me" />
        <meta name="twitter:description" content="Contact me for new projects, technologies, and design challenges." />
        <meta name="twitter:url" content="https://your-website-url.com/contact" />
        <meta name="twitter:image" content="https://your-website-url.com/twitter-card-image.jpg" />

        {/* LinkedIn Meta Tags */}
        <meta property="og:site_name" content="Your Website Name" />
        <meta property="og:image" content="https://your-website-url.com/linkedin-image.jpg" />

        {/* GitHub Meta Tags */}
        <meta name="github:card" content="summary" />
        <meta name="github:site" content="@your-github-username" />
      </Helmet>      
      <Navbar />
      <HeroImg />
      <Work/>
      <Footer />
    </div>
  );
};
 
